module.exports = __webpack_public_path__ + "static/img/share_ic2.b2b6288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_ic2.png
// module id = 4OwL
// module chunks = 1